// import React from 'react'
// import Footer from '../../components/Footer';
// import EducationImg from "../../assets/images/diplomao.jpeg";
// import { Link } from 'react-router-dom';
// import Title from '../../components/TitleComponent';

// const Education = () => {
//   return (
//     <div className='w-full relative font-poppins'>
//         <Title canonicalPath="/programmes/School-Of-Education" />
//         <Title title="Best Education College in Dehradun, Uttarakhand" description=" Maya Devi University is one of the best Engineering University in Dehradun, offering world-class Education programs in different Branches." />
//         <div className='w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5'>
//             <h2 className={`mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]`}>
//                 School of Education
//             </h2>
//             <div className='w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px]'></div>

//             <div className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between'>
//                 <img src={EducationImg} className='md:w-[40%] rounded-lg' alt="Education at Maya Devi University"/>
//                 <div className='flex flex-col gap-4'>
//                     <h4 className='font-bold text-xl md:text-3xl'>About the Department</h4>
//                     <p className='text-justify md:text-lg'>
//                         The School of Education at Maya Devi University is committed to shaping the future of education by nurturing competent and passionate educators. Our Bachelor of Education (B.Ed.) program is designed to equip aspiring teachers with the knowledge, skills, and values needed to inspire and educate the next generation. Rooted in academic excellence and practical learning, the program focuses on holistic teacher training, combining theoretical understanding with hands-on experience.
//                         <br/><br/>
//                         <strong>Course Highlights:</strong><br/>
//                         <ul className='list-disc text-[14px]'>
//                             <li>Comprehensive curriculum covering educational psychology, pedagogy, and subject-specific teaching methodologies</li>
//                             <li>Emphasis on developing modern teaching techniques and technology integration</li>
//                             <li>Extensive practical training through classroom observations, internships, and micro-teaching sessions</li>
//                             <li>Personality development and communication skills enhancement</li>
//                         </ul>
//                         <br/>
//                         <strong>Benefits of B.Ed. Program:</strong><br/>
//                         <ul className='list-disc text-[14px]'>
//                             <li>Professional Growth through in-depth knowledge and skills</li>
//                             <li>Practical exposure in real classroom environments</li>
//                             <li>Advanced teaching techniques and classroom management strategies</li>
//                             <li>Access to expert faculty and state-of-the-art infrastructure</li>
//                             <li>Strong foundation for diverse education sector roles</li>
//                         </ul>
//                     </p>
//                     <Link to="https://admission.maya.edu.in/">
//                         <button className='mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3]'>
//                             Register Now
//                         </button>
//                     </Link>
//                 </div>
//             </div>

//             <div className='flex flex-col gap-10 mt-5 mb-[50px]'>
//                 <div className='flex flex-col gap-2'>
//                     <h4 className={`text-2xl font-semibold text-[#0e4d38]`}>Career Opportunities</h4>
//                     <p>A B.Ed. degree from Maya Devi University opens up numerous career opportunities:</p>
//                     <ul className='list-disc ml-5 mt-2'>
//                         <li>School Teacher in primary, secondary, or senior secondary schools</li>
//                         <li>Educational Administrator in school management</li>
//                         <li>Content Developer for educational publishers</li>
//                         <li>Educational Counselor</li>
//                         <li>Corporate Trainer</li>
//                         <li>Educational Researcher</li>
//                     </ul>
//                 </div>
//             </div>

//             {/* Course Details Table */}
//             <div className="flex flex-col">
//                 <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
//                     <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
//                         <div className="overflow-hidden">
//                             <table className="min-w-full text-center text-sm font-light">
//                                 <thead className="border-b bg-[#23376c] font-medium text-white rounded-md">
//                                     <tr>
//                                         <th scope="col" className="px-6 py-4">Programme</th>
//                                         <th scope="col" className="px-6 py-4">Duration (Years)</th>
//                                         <th scope="col" className="px-6 py-4">No. of Seats</th>
//                                         {/* <th scope="col" className="px-6 py-4">One time Charges including Registration</th>
//                                         <th scope="col" className="px-6 py-4">Yearly Fee (All India Quota)</th>
//                                         <th scope="col" className="px-6 py-4">Yearly Fee (UK Domicile)</th> */}
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4 font-semibold">Bachelor of Education (B.Ed.)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">2</td>
//                                         <td className="whitespace-nowrap px-6 py-4">50</td>
//                                         {/* <td className="whitespace-nowrap px-6 py-4">Rs.21000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.85000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.65000/-</td> */}
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Hostel Fee Table */}
//             {/* <div className="flex flex-col mt-10 mb-10">
//                 <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
//                     <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
//                         <div className="overflow-hidden">
//                             <table className="min-w-full text-center text-sm font-light">
//                                 <thead className="border-b bg-[#23376c] font-medium text-white rounded-md">
//                                     <tr>
//                                         <th></th>
//                                         <th scope="col" className="px-6 py-4">Hostel Fee</th>
//                                         <th></th>
//                                     </tr>
//                                     <tr>
//                                         <th scope="col" className="px-6 py-4">Sr. No</th>
//                                         <th scope="col" className="px-6 py-4">Type</th>
//                                         <th scope="col" className="px-6 py-4">Fee</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">1</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Triple Sharing (Non AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">75000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">2</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Double Sharing (Non AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">85000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">3</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Triple Sharing (AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">115000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">4</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Double Sharing (AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">125000/-</td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//         </div>
//         <Footer/>
//     </div>
//   )
// }

// export default Education


import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../components/Footer';
import {
    GraduationCap,
    Stars,
    Clock,
    Bookmark,
    ArrowUpRight,
    Users,
    BookOpen,
    Award,
    Globe,
    Rocket,
    BookType,
    FlaskConical,
    Microscope,
    Stethoscope,
    FileText,
    Download,
    User,
    FileDigit,
    ShieldCheck,
    Users2,
    FileCheck,
    School,
    ArrowRight,
    Beaker,
    Trophy, Atom, Zap, Shield, LucideSearch, Activity, CheckCircle,
} from 'lucide-react';
import { Link } from 'react-router-dom';

import Title from '../../components/TitleComponent';
import Dean from "../../assets/schools/education/dean.jpg";
import overview from "../../assets/schools/education/overview.jpg";
import Why from "../../assets/schools/education/why.jpg";
import {
    TbPlant2,
    TbWorldWww,
    TbSchool,
    TbFlask,
    TbUsers,
    TbBriefcase,
    TbLeaf,
    TbTrophy,
    TbAward,
    TbQuote,

} from "react-icons/tb";
import { Target, Eye } from "lucide-react";
import { useState } from "react";





import Anil from '../../assets/schools/education/placement/Anil Singh.png';
import Deepak from '../../assets/schools/education/placement/Deepak.png';
import Diksha from '../../assets/schools/education/placement/DIKSHA.png';
import Naveen from '../../assets/schools/education/placement/Naveen.png';
import Saurabh from '../../assets/schools/education/placement/Saurabh.png';
import Shweta from '../../assets/schools/education/placement/shweta.png';

import Anil1 from '../../assets/schools/education/Anil.jpg';
import Diksha1 from '../../assets/schools/education/Diksha.png';
import Naveen1 from '../../assets/schools/education/Naveen.jpg';
import Saurabh1 from '../../assets/schools/education/Saurabh.jpg';
import Shubham1 from '../../assets/schools/education/Shubham.png';
import Shweta1 from '../../assets/schools/education/Shweta.png';


import EducationLogoSlider from '../../components/EducationLogoSlider';

const pharmacyCourses = {
    Diploma: [
        { name: "Diploma in Pharmacy (D.Pharm)", path: "best-d-pharma-college-in-dehradun-uttarakhand" },
    ],
    undergraduate: [
        { name: "Bachelor of Education (B. Ed.) ", path: "bsc-pcm-colleges-in-dehradun-uttarakhand" },

    ],
    postgraduate: [
        { name: "M.Sc. Botany", path: "/programmes/pg-courses/science/msc-botany" },
        { name: "M.Sc. Zoology", path: "/programmes/pg-courses/science/msc-zoology" },
        { name: "M.Sc. Chemistry", path: "/programmes/pg-courses/science/msc-chemistry" },
        { name: "M.Sc. Physics", path: "/programmes/pg-courses/science/msc-physics" },
        { name: "M.Sc. Mathematics", path: "/programmes/pg-courses/science/msc-mathematics" },
        { name: "M.Sc. Environmental Science", path: "/programmes/pg-courses/science/msc-environmental-science" },
        { name: "M.Sc. Forensic Science", path: "/programmes/pg-courses/science/msc-forensic-science" },
        { name: "M.Sc. Microbiology", path: "/programmes/pg-courses/science/msc-microbiology" },
        { name: "M.Sc. Biotechnology", path: "/programmes/pg-courses/science/msc-biotechnology" }
    ],
    doctorate: [
        { name: "Pharm D (Doctor of Pharmacy)", path: "/programmes/phd-courses/pharmacy/DoctorPharmacy" }
    ]
};


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-8 rounded-xl shadow-lg mb-12"
    >
        {/* Overview section with image - side by side on web, stacked on mobile */}
        <div className="flex flex-col lg:flex-row gap-8 items-center mb-10">
            <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                        <BookOpen className="w-6 h-6" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Overview</h2>
                </div>
                <div className="space-y-4 text-gray-700 text-lg">
                    <p>The School of Education is dedicated to shaping learners into knowledgeable, skilled, and passionate educators who contribute to the broader societal good through education. It focuses on preparing competent, compassionate, and innovative educators committed to promoting lifelong learning and the holistic development of students.
                        The School of Education is committed to providing world-class education by blending modern pedagogy with traditional values. Its state-of-the-art campus, well-stocked library, and cutting-edge technology ensure that students receive the best learning environment. The school emphasizes practical learning, encouraging students to engage in hands-on projects, research, and extracurricular activities, fostering critical thinking, creativity, and problem-solving skills.
                        A unique feature of the School of Education is its commitment to social responsibility. By organizing community outreach programs, workshops, and seminars, it instills in students a sense of empathy and a desire to contribute to society. Additionally, the school provides ample opportunities for students to excel in sports, cultural activities, leadership initiatives, and competitive exams.
                    </p>
                </div>
            </div>
            <div className="w-full lg:w-1/2 relative h-80 md:h-96 rounded-xl overflow-hidden shadow-xl">
                <img
                    src={overview}
                    alt="School of Education"
                    className="w-full h-full object-cover rounded-xl transition-transform duration-700 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e4d38]/70 to-transparent flex items-end">
                    <div className="p-6">
                        <h3 className="text-white text-xl font-bold">Cutting-edge Learning Environment</h3>
                        <p className="text-white/80 text-sm">Modern classrooms and advanced labs</p>
                    </div>
                </div>
            </div>
        </div>

        {/* Mission section - full width on web, normal on mobile */}
        <div className="w-full mb-10">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Mission</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>The mission of the School of Education includes several key objectives:<br />
                    1.	Develop Critical Thinking and Reflective Practices: Equip future educators with the ability to critically analyze and reflect on educational practices, enabling them to adapt to diverse classroom environments.<br />
                    2.	Enhance Pedagogical Skills: Provide future teachers with the necessary pedagogical knowledge and practical skills to design and deliver effective instruction across various educational settings.<br />
                    3.	Promote Inclusivity and Equity: Foster an understanding of diverse learner needs, emphasizing the importance of inclusivity, cultural competence, and social justice in education. <br />
                    4.	Inspire Leadership in Education: Encourage aspiring teachers to take on leadership roles within the classroom, schools, and communities, promoting positive change and educational innovation. <br />
                    5.	Prepare for Lifelong Professional Growth: Support the development of a mindset for continuous professional development, ensuring that educators stay current with trends in pedagogy, technology, and educational policy. <br />
                    The School of education in Maya Devi University, Dehradun, is more than an educational institution; it is a hub of inspiration, where dreams are nurtured, potential is realized, and future leaders are created. It continues to stand tall as a pillar of knowledge, growth, and professional progress.

                </p>
            </div>
        </div>

        {/* Vision section - full width on web, normal on mobile */}
        <div className="w-full">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Eye className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Vision</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>The vision of the School of Education is to shape learners to become knowledgeable, skilled, and passionate about shaping future generations and contributing to the broader societal good through education. It aims to prepare educators who are committed to lifelong learning and the holistic development of students.  </p>
            </div>
        </div>
    </motion.div>
);


const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 my-3 md:my-8 px-4"
    >
        {[
            // { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "01", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "48 LPA", label: "Heighest Package", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "500+", label: "Total Number of Students Placed", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);

const TestimonialCard = ({ student, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.2 }}
        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full"
    >
        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
            <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-gray-200 overflow-hidden">
                    <img
                        src={student.image}
                        alt={student.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div>
                    <h3 className="font-bold text-lg text-gray-800">{student.name}</h3>
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Building className="w-3 h-3" />
                        <span>{student.company}</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="p-6 flex-1 flex flex-col">
            <div className="text-[#0e4d38] mb-3">
                <MessageSquareQuote className="w-6 h-6" />
            </div>
            <p className="text-gray-700 italic flex-1">{student.testimonial}</p>

            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                {student.award && (
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Award className="w-4 h-4 text-[#0e4d38]" />
                        <span>{student.role}</span>
                    </div>
                )}
                {/* <div className="text-sm text-gray-500">Class of {student.graduationYear}</div> */}
            </div>
        </div>
    </motion.div>
);

const StudentTestimonials = () => {
    const testimonials = [
        {
            name: "Shubham Joshi ",
            role: "Asst. Prof. Tulas institute of engineering, Dehradun (B.Ed. batch ( 2022-2024 ))",
            quote: "What made my experience at Maya Devi University truly special was the vibrant and welcoming environment on campus. From exciting events like cultural fests and musical evenings to peaceful moments in the green surroundings, every aspect added value to my college life. The diverse student community helped me grow not just academically but personally too, forming lasting friendships and unforgettable memories. On the career front, the placement cell played a key role by organizing helpful workshops, interview prep, and resume sessions. Thanks to their support, I was able to land multiple job offers and today, I’m proud to be working in a top tech colleges—a goal I had set my sights on when I first joined ",
            image: Shubham1
        },
        {
            name: "Anil  Singh ",
            role: "Azim Prem Ji Foundation (B.Ed. Batch (2020-2022) ) ",
            quote: "Maya Devi University provides a supportive environment that fosters academic excellence and personal growth. The staff is approachable and helpful, and the students are friendly and collaborative. It has Excellent Faculty and Infrastructure. The college offers various opportunities for growth and development, including workshops, seminars, and extracurricular activities. These opportunities help students develop their skills, build their confidence, and become well-rounded individuals.   ",
            image: Anil1
        },
        {
            name: "Naveen Nautiyal  ",
            role: "FORESTER. Selected UKSSSC (B.Ed. batch (2021 -2023))",
            quote: "What made my experience at Maya Devi University is hard to put into words. What time passed in this College wasn't just a chapter in a book - it was the book itself which was filled with stories that i will cherish for a lifetime. The classrooms began spaces of curiosity the corridors- runways of laughter. I want to thank to our professors for being patient guides, they were more than teachers they were torch bearers who lit our paths even when we couldn't see clearly. I also want to thank to my fellow classmates for the memories. Maya Devi University, taught me more than any textbook ever could. It taught me resilience, responsibility, and the Power of genuine connection. This university gave me a lifetime of experience, lessons and love. Thank you Maya Devi University from the bottom of my heart. ",
            image: Naveen1
        },
        {
            name: "Diksha Jaiswal ",
            role: "Peer Review Associate Sage Publishing (B.Ed. Batch (2019-2021) )",
            quote: "Putting my experience at Maya Devi University into words is no easy task. My time here wasn't just a chapter in the story of my life—it was the entire book, filled with countless stories that I will cherish forever. The classrooms became spaces of endless curiosity, and the corridors turned into runways echoing with laughter. Every corner of the campus holds a memory, a moment, or a lesson that shaped who I am today. I am deeply grateful to our professors—not just for teaching us but for guiding us with patience and care. They were more than educators; they were torchbearers, illuminating our paths even when we couldn’t see the way ourselves. Maya Devi University taught me far beyond the boundaries of textbooks. It taught me resilience, responsibility, and the unmatched power of genuine human connection. This university has gifted me a lifetime’s worth of experience, growth, and love.Thank you, Maya Devi University—from the bottom of my heart.",
            image: Diksha1
        },
        {
            name: "Mrs. Shweta Naithani ",
            role: "Coordinator for Podar Education Network Mumbai  (B.Ed. Batch (2020-2022) )",
            quote: "What made my experience at Maya Devi University truly special was the vibrant and welcoming environment on campus. From exciting events like cultural fests and musical evenings to peaceful moments in the green surroundings, every aspect added value to my college life. The diverse student community helped me grow not just academically but personally too, forming lasting friendships and unforgettable memories. On the career front, the placement cell played a key role by organizing helpful workshops, interview prep, and resume sessions. Thanks to their support, I was able to land multiple job offers and today, I’m proud to be working in a top tech colleges—a goal I had set my sights on when I first joined.",
            image: Shweta1
        },
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-xl shadow-lg mb-12"
        >
            <div className="flex items-center gap-3 mb-8">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Users className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Student Testimonials</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {testimonials.map((testimonial, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.2 }}
                        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full hover:shadow-lg transition-all duration-300"
                    >
                        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
                            <div className="flex items-center gap-3">
                                <div className="w-14 h-14 rounded-full overflow-hidden">
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="w-full h-full object-cover"
                                        loading="lazy"
                                    />
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-gray-800">{testimonial.name}</h3>
                                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                                </div>
                            </div>
                        </div>

                        <div className="p-6 flex-1 flex flex-col">
                            <div className="text-[#0e4d38] mb-3">
                                <TbQuote size={24} />
                            </div>
                            <p className="text-gray-700 italic flex-1">{testimonial.quote}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            {course.name.toLowerCase().includes('pharm d') ? (
                                <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : course.name.toLowerCase().includes('m.pharm') ? (
                                <BookType className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : (
                                <FlaskConical className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            )}
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>
                            {course.name.includes('D.Pharm') ? '2 Years' :
                                course.name.includes('B.Pharm - LE') ? '3 Years' :
                                    course.name.includes('B.Pharm') ? '4 Years' :
                                        course.name.includes('M.Pharm') ? '2 Years' :
                                            course.name.includes('Pharm D') ? '6 Years' : 'Duration'}
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>
                            {course.name.includes('M.Pharm') ? 'PG' :
                                course.name.includes('Pharm D') ? 'Doctor' : 'UG'}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>

        {/* Diploma Programs */}
        {/* <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Diploma Program</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.Diploma.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div> */}
        {/* Undergraduate Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Undergraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.undergraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>

        {/* Postgraduate Programs */}
        {/* <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Postgraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.postgraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div> */}

        {/* Doctorate Programs */}
        {/* <div>
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Doctor Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.doctorate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div> */}
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-white py-12 md:py-20 px-6 md:px-10 rounded-xl mb-8 md:mb-12">
        <div className="absolute inset-0 bg-[url('/api/placeholder/1600/800')] bg-cover bg-center opacity-10 mix-blend-overlay" aria-hidden="true"></div>
        <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>
        <div className="absolute -left-20 -top-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>

        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-6xl mx-auto relative z-10"
        >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
                School of Education
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-green-100">
                Shaping Tomorrow's Leaders at Maya Devi University
            </h2>

            <div className="flex flex-wrap gap-4 md:gap-6">
                <Link to="https://admission.maya.edu.in/">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-white text-[#0e4d38] px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group shadow-lg"
                    >
                        Apply Now
                        <Rocket className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link>
                {/* <Link to="#programs">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-transparent border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group"
                    >
                        Explore Programs
                        <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link> */}
            </div>
        </motion.div>
    </div>
);

// Dean Section Component
const DeanSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg overflow-hidden"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                <GraduationCap className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">Principal’s Welcome Message: </h4>
        </div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center">
            <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center">
                <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="rounded-xl overflow-hidden max-w-[250px]"
                >
                    <img
                        src={Dean}
                        alt="Dr. Sita Juyal  "
                        className="w-[250px] h-[250px] object-contain bg-white rounded-xl shadow-lg"
                    />
                </motion.div>
                <div className="text-center mt-3">
                    <h5 className="font-bold text-lg text-gray-800">Dr. Sita Juyal  </h5>
                    <p className="text-sm text-gray-600">Principal  , School of Education (B.Ed.) Maya Devi University Dehradun </p>
                </div>
            </div>

            <div className="w-full md:w-2/3 lg:w-3/4 flex flex-col justify-center h-full">
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    “Our lives are defined by the opportunities, even the ones that we missed” <br />
                    The School of Education of Maya Devi University, Dehradun has been a fascinating journey defined by our students' dedication and tenacity. B.Ed. students consistently post boundaries in the rich capacity of diverse learning experience embracing challenges with the spirit that aligns with our university ethos.

                </p>
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    At the heart of our teaching methodology is a genuine belief in our students holistic development a commitment that extend beyond academic prowess to facilitate personal and professional growth.
                </p>
                <p className="text-gray-700 text-sm md:text-base">
                    It gives me great pleasure to recognize our students' extraordinary accomplishments in navigating academia, Co-curricular and the arts with grace. The academic structure, which emphasizes language acquisition, merges effortlessly with a commitment to promoting selfconfidence and adaptability-qualities critical for success in our ever-changing global context.
                </p>
                {/* <p className="text-gray-700 text-sm md:text-base">
                    Join us to be part of a progressive scientific community that is shaping the future through education, exploration, and excellence.
                </p> */}
            </div>
        </div>
    </motion.div>
);





const PharmacyDepartment = () => {
    // Data for Global Opportunities
    const globalOpportunities = [
        {
            title: "Licensing Exams",
            items: [
                "FPGEE (Foreign Pharmacy Graduate Equivalency Exam)",
                "GPhC Registration Exam (UK)",
                "NAPLEX (USA)",
                "PEBC (Canada)"
            ]
        },
        {
            title: "Higher Education",
            items: [
                "Postgraduate Programs Abroad",
                "Research Fellowships",
                "Ph.D. Opportunities"
            ]
        },
        {
            title: "Certifications",
            items: [
                "Clinical Pharmacy Certification (FCCP)",
                "Pharmaceutical Sciences Certifications",
                "Regulatory Affairs Certifications"
            ]
        }
    ];

    // Placements Data
    const placements = [
        { name: "Arpit", company: "Cipla Pharmaceuticals", position: "Assistant Manager", ctc: "5.5 LPA", image: Anil },
        { name: "Asha", company: "East African Overseas", position: "Senior Officer", ctc: "3.3 LPA", image: Deepak },
        { name: "Kuldeep Kumar", company: "Mankind Pharma", position: "Business Executive", ctc: "5 LPA", image: Diksha },
        { name: "Ravi Kumar", company: "NKG Advisory", position: "Officer", ctc: "1.8 LPA", image: Naveen },
        { name: "Suhail Bashir Khan", company: "Govt District Hospital", position: "Pharmacist", ctc: "4.80 LPA", image: Saurabh },
        { name: "Jeewan Chandra Joshi", company: "Zee Lab Ltd", position: "Sr Executive", ctc: "6.90 LPA", image: Shweta },
    ];



    // Patents Data
    const patents = [
        "Dissolution Testing Apparatus To Simulate Colonic BioEnvironment",
        "Portable Electro Spinning Device For Development Of Nanofibres",
        "T-Maze Apparatus For Detection Of Locomotor Activity",
        "Variable Speed Rotating Drum",
        "Oil Filled Coverslip For Microscope",
        "Gas Chromatography Mass Spectrometer Apparatus",
        "Modified Silverson Mixer Emulsifier For Nanoparticle Synthesis"
    ];

    // Clubs Data
    const clubs = [
        {
            name: "Sports Clubs",
            icon: <TbTrophy size={24} />,
            description: "Promotes physical fitness, teamwork, and healthy competition through various sports activities."
        },
        {
            name: "Academic Clubs",
            icon: <TbUsers size={24} />,
            description: "Celebrates creativity through workshops, exhibitions, and cultural festivals."
        },
        {
            name: "Cultural Clubs",
            icon: <TbBriefcase size={24} />,
            description: "Bridges clinical knowledge with management skills for future healthcare leaders."
        },
        {
            name: "Career Exploration",
            icon: <TbLeaf size={24} />,
            description: "Promotes environmental awareness through sustainability initiatives."
        },
        {
            name: "Hobby Clubs",
            icon: <TbUsers size={24} />,
            description: "Advocates for gender equality and women's professional growth."
        }
    ];
    const societies = [
        {
            name: "Indian Chemical Society ",
            icon: <TbTrophy size={24} />,
            description: "Promotes physical fitness, teamwork, and healthy competition through various sports activities."
        },
        {
            name: "Institute of Chemistry of Ireland ",
            icon: <TbUsers size={24} />,
            description: "Celebrates creativity through workshops, exhibitions, and cultural festivals."
        },
        {
            name: "American Chemical Society ",
            icon: <TbBriefcase size={24} />,
            description: "Bridges clinical knowledge with management skills for future healthcare leaders."
        },

    ];

    // Testimonials Data
    const testimonials = [
        {
            name: "Rashmi Sharma",
            role: "Senior Officer, East African Overseas",
            quote: "It's hard to put into words what this college has given me — knowledge, confidence, friendships, and memories that will last a lifetime.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Kuldeep Kumar",
            role: "Business Executive, Mankind Pharma",
            quote: "The faculty was supportive, the campus environment inspiring, and the opportunities for growth were endless.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Abhinav Rawat",
            role: "B.Pharm Graduate",
            quote: "The supportive environment and excellent facilities make Maya Devi University a great choice for aspiring pharmacists.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Mahak",
            role: "B.Pharm Student",
            quote: "Our faculty members are extremely supportive and always willing to guide us through challenging topics.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Analisha Debbarma",
            role: "B.Pharm Student",
            quote: "I'm proud to be part of a place that values diversity and supports students from all backgrounds.",
            image: "/api/placeholder/300/300"
        }
    ];

    // State for active testimonial
    const [activeTestimonial, setActiveTestimonial] = useState(0);
    const [showCertificate, setShowCertificate] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const InfiniteSlider = ({ placements }) => {
        return (
            <div className="relative">
                {/* Mobile View - Grid Layout */}
                <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {placements.map((student, index) => (
                        <div
                            key={`mobile-${index}`}
                            className="w-full h-full flex justify-center items-center"
                        >
                            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                <div className="relative overflow-hidden h-72 w-full">
                                    <img
                                        src={student.image}
                                        alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                        <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                        {student.name && (
                                            <p className="text-white text-xs">{student.name}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Desktop View - Infinite Slider */}
                <div className="hidden md:block overflow-hidden w-full">
                    <div className="flex animate-infinite-scroll">
                        {/* First set */}
                        {placements.map((student, index) => (
                            <div
                                key={`first-${index}`}
                                className="flex-shrink-0 w-[300px] mx-4"
                            >
                                <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                    <div className="relative overflow-hidden h-72 w-full">
                                        <img
                                            src={student.image}
                                            alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                            className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                            loading="lazy"
                                        />
                                        {/* <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                            <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                            {student.name && (
                                                <p className="text-white text-xs">{student.name}</p>
                                            )}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* Second and third sets remain the same */}
                        {/* ... existing second and third sets code ... */}
                    </div>
                </div>
            </div>
        );
    };


    const WhyUsSection = () => {
        const features = [
            // {
            //     icon: <Zap className="w-7 h-7" />,
            //     title: "Strong Academic Foundation:",
            //     description: "We deliver high-quality education through wellstructured programs, qualified faculty, and a modern curriculum aligned with industry standards. "
            // },
            {
                icon: <Shield className="w-7 h-7" />,
                title: "Practical Application: ",
                description: "❖	The School of Education of Maya Devi University We are committed to nurturing the next generation of inspiring pupil teachers."
            },
            {
                icon: <Globe className="w-7 h-7" />,
                title: "Interdisciplinary Nature: ",
                description: "We blend theoretical foundations with hands-on teaching practice to develop skilled, reflective, and compassionate educators ready to shape the future. "
            },
            {
                icon: <LucideSearch className="w-7 h-7" />,
                title: "Career Opportunities: ",
                description: "Learn from passionate educators, researchers, and practitioners who bring realworld insights into the classroom. "
            },
            {
                icon: <Users className="w-7 h-7" />,
                title: "Personal Growth: ",
                description: "Maya Devi University offers smart classrooms, well-equipped labs, a rich library, and digital teaching tools. "
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Continuous Learning: ",
                description: "School of Education, we focus on ethics, inclusion, and child-centered pedagogy to prepare future educators. Our B.Ed. program emphasizes moral foundations, inclusive practices, and fostering a harmonious classroom environment.  "
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Affordable Education: ",
                description: "Strong school partnerships ensure practical experience and career guidance through teaching internships and placement assistance.  "
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Real-World Impact:  ",
                description: "❖	Workshops on communication skills, leadership, mental well-being and professional grooming make confident. "
            }
        ];

        return (
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white p-8 rounded-xl shadow-lg mb-12"
            >
                <div className="flex flex-col md:flex-row gap-8">
                    <div className="w-full md:w-1/3">
                        <div className="sticky top-24">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                                    <CheckCircle className="w-6 h-6" />
                                </div>
                                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Why Join Us?</h2>
                            </div>
                            {/* <p className="text-gray-700 mb-6">The School of Life and Applied Sciences offers students a unique opportunity to explore one of the most dynamic and essential fields of science. With a blend of innovative teaching methods and cutting-edge research, our department fosters an environment where curiosity and creativity thrive. Students benefit from projector based classrooms, personalized mentorship, and access to modern lab facilities, ensuring they receive the hands-on experience crucial for mastering complex concepts. Our school is committed to providing diverse learning opportunities, from undergraduate research projects to internships with industry leaders. Moreover, students are encouraged to participate in science clubs, workshops, and seminars, further enhancing their academic experience.  </p> */}
                            <div className="relative h-60 md:h-80 rounded-lg overflow-hidden">
                                <img
                                    src={Why}
                                    alt="Students collaborating"
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0e4d38] to-transparent p-4">
                                    <p className="text-white font-semibold">Joining Maya Devi University means becoming part of a progressive academic community dedicated to shaping future leaders, professionals, and innovators. </p>
                                </div>
                            </div>
                            <div className="mt-6">
                                <Link to="https://admission.maya.edu.in/">
                                    <motion.button
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        className="w-full bg-[#0e4d38] text-white px-6 py-3 rounded-lg text-lg font-semibold flex items-center justify-center gap-2"
                                    >
                                        Apply Now
                                        <ArrowRight className="w-5 h-5" />
                                    </motion.button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-2/3">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: index * 0.1 }}
                                    className="bg-gray-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
                                >
                                    <div className="text-[#0e4d38] mb-4">
                                        <div className="p-3 bg-[#0e4d38]/10 rounded-lg inline-block">
                                            {feature.icon}
                                        </div>
                                    </div>
                                    {/* <h3 className="text-xl font-bold mb-3 text-gray-800">{feature.title}</h3> */}
                                    <p className="text-gray-600">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.div>
        );
    };

    // Function to move to next testimonial
    const nextTestimonial = () => {
        setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    };

    // Function to move to previous testimonial
    const prevTestimonial = () => {
        setActiveTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const viewCertificate = (index) => {
        setSelectedIndex(index);
        setShowCertificate(true);
    };

    const closeCertificate = () => {
        setShowCertificate(false);
    };
    return (
        <div className="font-sans">

            {/* 4. Global Opportunities Section */}
            {/* <section className="py-16 bg-gradient-to-r from-emerald-800 to-emerald-600 text-white">
                <div className="container mx-auto px-4">
                    <div className="bg-white/10 p-10 rounded-2xl backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-300 shadow-md">
                        <h2 className="text-3xl font-bold text-white mb-6">Global Opportunities</h2>
                        <ul className="space-y-6 text-white text-lg leading-relaxed">
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Postgraduate students are mentored for higher studies and research in top-ranking global institutions.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    The curriculum aligns with international academic standards, preparing students for exams like GRE, TOEFL, and IELTS for global education pathways.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Chemistry graduates can pursue global careers as Research Chemists, Analytical Chemists, Medicinal Chemists, Food Chemists, Computational Chemists, Polymer Chemists, QC Chemists, Nuclear Chemists, and more in sectors like pharma, healthcare, agriculture, and industry.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Environmental Science, Botany, Zoology, Microbiology, and Biotechnology graduates find roles in global research organizations, government agencies, and private sector industries.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Zoologists can contribute to global conservation initiatives with organizations like WWF, UNEP, and CITES. International research opportunities also exist via ZSI, WWI, DRDO, UCOST, CSIR, ICAR, and other global collaborations.
                                </span>
                            </li>
                        </ul>
                    </div>

                </div>
            </section> */}

            {/* 5.	Program Names:  */}
            <div className="space-y-6 md:space-y-8">
                <Department
                    title="Programs"
                    icon={<Microscope className="w-5 h-5 md:w-6 md:h-6" />}
                />
            </div>

            {/* Dean Section */}
            <DeanSection />

            {/* 7.Students' Achievements / Placements:  */}
            <section className="py-20 bg-gradient-to-b from-gray-50 to-gray-100">
                <div className="container mx-auto px-4">
                    <div className="mb-14 text-center">
                        <h2 className="text-4xl font-bold mb-5 text-emerald-800 relative inline-block">
                            Student Placements
                            {/* <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-emerald-500 rounded-full"></span> */}
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Our graduates are making an impact in prestigious organizations worldwide
                        </p>
                    </div>

                    {/* Infinite Slider */}
                    <div className="overflow-hidden">
                        <InfiniteSlider placements={placements} />
                    </div>
                </div>
            </section>

            {/* <PlacementPartners /> */}
            <EducationLogoSlider />

            <WhyUsSection />


            {/*10. Awards & Patents Section - Modernized with green theme */}




            {/* 11. Clubs Section - Modernized with green theme */}
            


            {/*12.  StudentTestimonials */}
            <StudentTestimonials testimonials={testimonials} />

            {/* Call to Action */}
            {/* <section className="py-16 bg-gradient-to-br from-emerald-600 to-emerald-800 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-4xl font-bold mb-6">Begin Your Pharmaceutical Journey</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Join our prestigious School of Pharmacy and become part of the next generation of pharmaceutical innovators.
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <button className="bg-white text-emerald-800 px-8 py-4 rounded-full font-semibold hover:bg-emerald-50 transition-colors">
                            <Link to="https://admission.maya.edu.in/"> Apply Now </Link>
                        </button>
                        
                    </div>
                </div>
            </section> */}
        </div>
    );
};


// PDF Document Card Component
const DocumentCard = ({ document }) => (
    <motion.div
        whileHover={{ scale: 1.02 }}
        className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300"
    >
        <div className="p-4">
            <div className="flex justify-between items-center mb-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                    {document.icon}
                </div>
                <a href={document.path} download>
                    <motion.div
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                        className="p-2 bg-gray-50 hover:bg-gray-100 rounded-full"
                    >
                        <Download className="w-4 h-4 text-gray-600" />
                    </motion.div>
                </a>
            </div>
            <h3 className="font-semibold text-gray-800 mb-1 text-sm md:text-base">{document.name}</h3>
            <p className="text-gray-600 text-xs md:text-sm mb-3">{document.description}</p>
            <a
                href={document.path}
                download
                className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-[#0e4d38] hover:text-[#0a3b2a] transition-colors"
            >
                Download PDF
                <ArrowUpRight className="w-3 h-3" />
            </a>
        </div>
    </motion.div>
);

// PDF Resources Section
const ResourcesSection = ({ category }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {category.icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{category.title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {category.documents.map((doc, index) => (
                <DocumentCard key={index} document={doc} />
            ))}
        </div>
    </motion.div>
);

const Education = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins mt-[70px]">
            <Title canonicalPath="/programmes/School-Of-Education" />
            <Title title="School of Education at Maya Devi University, Dehradun" description=" Join the School of Education at Maya Devi University, Dehradun. Pursue a rewarding career in Education with expert knowledge and practical skills in Education." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <AboutSection />
                <Stats />
                <PharmacyDepartment />

                {/* <StudentAchievements /> */}


                {/* PDF Resources Sections */}
                {/* <div className="space-y-6 md:space-y-8">
                    {pdfResources.map((category, index) => (
                        <ResourcesSection key={index} category={category} />
                    ))}
                </div> */}

                {/* <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "PCI Approved Programs",
                            "Experienced Faculty with Industry Background",
                            "State-of-the-art Laboratories",
                            "Industry-Integrated Curriculum",
                            "Hands-on Training",
                            "Research Opportunities",
                            "Regular Industrial Visits",
                            "Modern Teaching Methods",
                            "Well-equipped Library",
                            "Industry Collaboration",
                            "Mentorship Program",
                            "Career Development Support"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Stethoscope className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Clinical Pharmacist",
                            "Hospital Pharmacist",
                            "Research Scientist",
                            "Drug Safety Associate",
                            "Quality Control Manager",
                            "Regulatory Affairs Officer",
                            "Production Manager",
                            "Medical Writer",
                            "Pharmaceutical Sales",
                            "Drug Inspector",
                            "Academic Researcher",
                            "Healthcare Consultant"
                        ]}
                    />
                </div> */}
            </div>
            <Footer />
        </div>
    );
};

export default Education;